import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'filter',
  version: '1.1.0',
  // This node iterates over input arrays - expressions should use .output.item to reference current item
  iteratesOverItems: true,
  properties: [
    {
      key: 'inputArray',
      label: 'Input Array',
      type: 'string',
      required: true,
      placeholder: '{{ $node["NodeName"].array }}',
      description: 'The array to filter. Drag from the input panel or type the path.',
    },
    {
      key: 'conditions',
      label: 'Conditions',
      type: 'fixedCollection',
      required: true,
      typeOptions: {
        multipleValues: true,
      },
      default: {
        values: [
          {
            field: '',
            operator: '===',
            value: '',
          },
        ],
      },
      fixedCollectionOptions: [
        {
          name: 'values',
          displayName: 'Condition',
          description: 'Add conditions to filter the array',
          values: [
            {
              key: 'field',
              label: 'Field',
              type: 'options',
              required: true,
              placeholder: 'Select a field',
              description: 'The field name to filter on',
              options: [],
              typeOptions: {
                // Load field options dynamically from the inputArray parameter
                loadOptionsFrom: 'inputArray',
              },
            },
            {
              key: 'operator',
              label: 'Operator',
              type: 'options',
              required: true,
              default: '===',
              options: [
                { value: '===', name: 'Equals' },
                { value: '!==', name: 'Not Equals' },
                { value: '>', name: 'Greater Than' },
                { value: '>=', name: 'Greater Than or Equal' },
                { value: '<', name: 'Less Than' },
                { value: '<=', name: 'Less Than or Equal' },
                { value: 'contains', name: 'Contains' },
                { value: 'startsWith', name: 'Starts With' },
                { value: 'endsWith', name: 'Ends With' },
                { value: 'regex', name: 'Regex Match' },
                { value: 'isEmpty', name: 'Is Empty' },
                { value: 'isNotEmpty', name: 'Is Not Empty' },
              ],
            },
            {
              key: 'value',
              label: 'Value',
              type: 'string',
              placeholder: 'e.g., 5000',
              description: 'The value to compare against',
              displayOptions: {
                hide: {
                  operator: ['isEmpty', 'isNotEmpty'],
                },
              },
            },
          ],
        },
      ],
    },
    {
      key: 'combineOperation',
      label: 'Combine',
      type: 'options',
      default: 'AND',
      options: [
        { value: 'AND', name: 'AND (all must match)' },
        { value: 'OR', name: 'OR (any must match)' },
      ],
      description: 'How to combine multiple conditions',
    },
    {
      key: 'keep',
      label: 'Keep',
      type: 'options',
      default: 'matching',
      options: [
        { value: 'matching', name: 'Items that match' },
        { value: 'nonMatching', name: 'Items that do NOT match' },
      ],
      description: 'Whether to keep items that match the conditions or items that do not match',
    },
  ],
};

export default schema;
